<ng-container *transloco="let t; read: 'admin.tenants.detailPage'">
  <div class="grid grid-cols-1 items-stretch gap-5 lg:grid-cols-2 xl:grid-cols-3">
    <!-- Details -->
    <div class="rounded-card bg-card p-6 shadow-hairline">
      <div class="mb-4 font-display text-[13px] font-semibold uppercase tracking-wide text-ink-2">{{ t('cards.details') }}</div>
      @if (tenant(); as tn) {
        <div class="grid grid-cols-[110px_1fr] items-center gap-y-3.5 text-[13px] text-ink-1">
          <span class="text-[11px] uppercase text-ink-3">{{ t('fields.tenantId') }}</span>
          <span class="break-all font-num text-[12px] text-ink-2">{{ tn.id }}</span>

          <span class="text-[11px] uppercase text-ink-3">{{ t('fields.alias') }}</span>
          <span class="truncate">{{ tn.alias }}</span>

          <span class="self-start text-[11px] uppercase text-ink-3">{{ t('fields.domains') }}</span>
          <span class="flex min-w-0 flex-col gap-1.5">
            @for (domain of tn.domains ?? []; track domain.name) {
              <span class="flex items-center gap-2">
                <span class="truncate">{{ domain.name }}</span>
                <app-label-badge [dot]="domain.verified ? 'green' : null">{{ domain.verified ? t('fields.verified') : t('fields.unverified') }}</app-label-badge>
              </span>
            } @empty {
              <span class="text-ink-3">{{ t('fields.noDomains') }}</span>
            }
          </span>

          @if (tn.description) {
            <span class="text-[11px] uppercase text-ink-3">{{ t('fields.description') }}</span>
            <span class="truncate">{{ tn.description }}</span>
          }

          <!-- created is null for orgs predating server stamping — keep the dash. -->
          <span class="text-[11px] uppercase text-ink-3">{{ t('fields.created') }}</span>
          @if (tn.created) {
            <span>{{ tn.created | date: 'mediumDate' }}</span>
          } @else {
            <span class="text-ink-3">{{ t('dash') }}</span>
          }

          <span class="text-[11px] uppercase text-ink-3">{{ t('fields.contact') }}</span>
          @if (tn.contact) {
            <a [href]="'mailto:' + tn.contact" class="truncate text-brand">{{ tn.contact }}</a>
          } @else {
            <span class="text-ink-3">{{ t('dash') }}</span>
          }

          <span class="text-[11px] uppercase text-ink-3">{{ t('fields.region') }}</span>
          @if (tn.region) {
            <span class="truncate">{{ tn.region }}</span>
          } @else {
            <span class="text-ink-3">{{ t('dash') }}</span>
          }

          <span class="text-[11px] uppercase text-ink-3">{{ t('fields.sso') }}</span>
          @if (tn.ssoConfigured) {
            <span class="inline-flex items-center gap-2">
              <span class="h-2.5 w-2.5 rounded-full bg-success"></span>
              {{ ssoProviderNames() ? t('fields.ssoEnabled', { providers: ssoProviderNames() }) : t('fields.ssoEnabledGeneric') }}
            </span>
          } @else {
            <span class="text-ink-3">{{ t('fields.ssoNone') }}</span>
          }
        </div>
      }
    </div>

    <!-- Users -->
    <div class="flex flex-col rounded-card bg-card p-6 shadow-hairline">
      <div class="mb-3.5 flex items-baseline justify-between">
        <span class="font-display text-[13px] font-semibold uppercase tracking-wide text-ink-2">{{ t('cards.users') }}</span>
        <span
          class="font-num text-2xl font-semibold"
          [class.text-ink-1]="usersTotal() !== null"
          [class.text-ink-3]="usersTotal() === null"
          >{{ usersTotal() ?? t('dash') }}</span
        >
      </div>
      @if (memberPreview().length) {
        <div class="flex items-center gap-1.5">
          @for (member of memberPreview(); track member.id) {
            <span
              class="inline-flex h-[30px] w-[30px] items-center justify-center rounded-full bg-sunken text-[11px] font-semibold text-ink-1"
              [title]="member.email"
              >{{ initials(member) }}</span
            >
          }
          @if (extraMemberCount() > 0) {
            <span class="inline-flex h-[30px] w-[30px] items-center justify-center rounded-full text-[11px] text-ink-3 shadow-hairline">
              +{{ extraMemberCount() }}
            </span>
          }
        </div>
      } @else if (usersTotal() === 0) {
        <p class="m-0 text-[13px] leading-5 text-ink-3">{{ t('cards.usersEmpty') }}</p>
      } @else {
        <p class="m-0 text-[13px] leading-5 text-ink-3">{{ t('cards.usersUnavailable') }}</p>
      }
      <div class="min-h-4 flex-1"></div>
      <button
        type="button"
        (click)="manageUsers()"
        class="w-full rounded-control border border-hairline bg-card px-4 py-2.5 text-[14px] font-semibold text-ink-1 hover:bg-sunken"
      >
        {{ t('cards.manageUsers') }}
      </button>
    </div>

    <!-- Displays -->
    <div class="flex flex-col rounded-card bg-card p-6 shadow-hairline">
      <div class="mb-3.5 flex items-baseline justify-between">
        <span class="font-display text-[13px] font-semibold uppercase tracking-wide text-ink-2">{{ t('cards.displays') }}</span>
        <span class="font-num text-2xl font-semibold text-ink-3">{{ t('dash') }}</span>
      </div>
      <p class="m-0 text-[13px] leading-5 text-ink-3">{{ t('cards.displaysUnavailable') }}</p>
    </div>
  </div>
</ng-container>
